import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation, Link  } from 'react-router-dom';
import { useBookpalNavigate } from 'component/common/custom/BookpalLink';

import style from './Refund.module.scss';
import { appSetClose } from 'utils/AppUtil';

function RefundResultSuccess(props){


    return (
        <>
            {/* <!-- 충전 헤더 --> */}
            <div id="TopHeader" className={"color-bg-01 title_header " + style['TopHeader'] + " " + style['title_header']}>
                
                <div className={"title_menu wrapper " + style['title_menu']}>
                    
                    <div className={"btns left_btns " + style['btns'] + " " + style['left_btns']}></div>
                    <div className={"title-04 color-txt-normal text_overflow " + style['text_overflow'] + " " + style['title-04']}>환불 완료</div>
                    <div className={"btns right_btns " + style['btns'] + " " + style['right_btns']}>
                        <button 
                            type="button" 
                            className={"close_btn " + style['close_btn']} 
                            onClick={()=>{
                                window.close();
                                appSetClose();
                            }}
                            ></button>
                    </div>
                </div>
            </div>

            {/* <!-- container --> */}
            <div id="container" className={"s_wrap wrapper " + style['container'] + " " + style['s_wrap'] + " " + style['wrapper']} style={{marginTop:"0", marginBottom:"0px"}}>
                <section className={"charge_box " + style['charge_box']}>
                    <div className={"area_box " + style['area_box']}>
                        <div className={"center " + style['center']}>
                            <p className="color-txt-normal" style={{textAlign:"center"}}>신청하신 계좌로 환불 처리가 정상적으로 완료되었음을 알려드립니다.</p>
                        </div>
                        <div className={"temp_list_type section " + style['temp_list_type'] + " " + style['section']} style={{padding:"0"}}>
                            <div className={"list " + style['list']} > 
                                <div className="list_1" style={{display:""}}>
                                    

                                    <div className={"tit_con section clearfix " + style['tit_con'] } style={{height:"auto",letterSpacing:"0.5px", lineHeight:"1.3",paddingBottom:"20px"}}>
                                        <div className={"grade_up  radius-sm red_opacity-05 bg " + style['grade_up'] + " " + style['top_con'] + " " + style['bg']} style={{padding:"20px",backgroundColor:"#eee",width:"100%"}}>
                                            <p className={"title body-01 color-txt-muted " + style['title']}><span className="color-txt-normal" style={{fontSize:"0.85rem", lineHeight:"1.0",width:"100%"}}>
                                                <div className={"my_coupon radius-sm bg clearfix " + style['my_coupon']} style={{width:"100%", display:"block",textAlign:"center",alignItems:"center",marginBottom:"20px"}}>
                                                    <div className={"left " + style['left']} style={{paddingLeft:"0px"}}>
                                                        <p className="title-01-b color-txt-normal">최종 환불 금액</p>
                                                    </div>
                                                </div>
                                                <div className={"my_coupon radius-sm bg clearfix " + style['my_coupon']} style={{width:"100%", display:"block",textAlign:"center",alignItems:"center"}}>
                                                    <div className={"left " + style['left']} style={{paddingLeft:"0px"}}>
                                                        <p className="title-01-b color-txt-normal" style={{fontSize:"1.5rem"}}>{props?.refundCouponPrice} 원</p>
                                                    </div>
                                                </div>
                                            </span>
                                            {/* 매월 1일, 최근 3개월 결제금액에 따라 결정됩니다. */}
                                            </p>
                                        </div>
                                        
                                    </div>
                                    <div className="list_1" style={{display:""}}>
                                    

                                        <div className={"tit_con section clearfix " + style['tit_con'] } style={{height:"auto",letterSpacing:"0.5px", lineHeight:"1.3"}}>
                                            <div className={"grade_up  radius-sm red_opacity-05 bg " + style['grade_up'] + " " + style['top_con'] + " " + style['bg']} style={{backgroundColor:"#fff",width:"100%"}}>
                                                <p className={"title body-01 color-txt-muted " + style['title']}><span className="color-txt-normal" style={{fontSize:"0.85rem", lineHeight:"1.0",width:"100%"}}>
                                                    
                                                    
                                                    <div className={"my_coupon radius-sm bg clearfix " + style['my_coupon']} style={{width:"100%", display:"flex",alignItems:"center",marginBottom:"20px"}}>
                                                        <div className={"left " + style['left']} style={{paddingLeft:"0px"}}>
                                                            <p className="title-01-b color-txt-normal">환불 대상</p>
                                                        </div>
                                                        <div className={"right " + style['right']} style={{paddingRight:"0px"}}>
                                                            <p className="number title-01-b color-txt-normal">유료 쿠폰 {props?.refundCouponCnt} 개</p>
                                                        </div>
                                                    </div>
                                                    <div className={"my_coupon radius-sm bg clearfix " + style['my_coupon']} style={{width:"100%", display:"flex",alignItems:"center",marginBottom:"20px"}}>
                                                        <div className={"left " + style['left']} style={{paddingLeft:"0px"}}>
                                                            <p className="title-01-b color-txt-normal">입금 계좌</p>
                                                        </div>
                                                        <div className={"right " + style['right']} style={{paddingRight:"0px"}}>
                                                            <p className="number title-01-b color-txt-normal">{props?.acctBankNm} ({props?.acctHolder})</p>
                                                        </div>
                                                    </div>
                                                </span>
                                                {/* 매월 1일, 최근 3개월 결제금액에 따라 결정됩니다. */}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"center " + style['center']} style={{marginTop:"40px"}}>
                            <p className="color-txt-normal" style={{textAlign:"center"}}>입금 확인은 이용하시는 은행 앱을 통해 가능합니다.</p>
                        </div>
                        
                    </div>
                </section>
            </div>
            {/* <AlertModal /> */}
            {/* <!-- container --> */}

            {/* <Footer /> */}
        </>
    );
}

export default RefundResultSuccess;